import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter as Router, Routes, Route } from 'react-router'
// if you want to use React Query Devtools for order history
// uncomment line 6 and line 30 of this file
//import { ReactQueryDevtools } from 'react-query/devtools'

import OrderIndexView from '../components/order-index-view.jsx'
import OrderShowView from '../components/order-show-view.jsx'

const thirtyMinutes = 30 * 60 * 1000
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: thirtyMinutes,
      cacheTime: thirtyMinutes
    }
  }
})

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route
            path={`/order_history/:id`}
            element={<OrderShowView />}
          />
          <Route
            path="/order_history"
            element={<OrderIndexView />}
          />
        </Routes>
      </Router>
      {/*{<ReactQueryDevtools initialIsOpen={false} />}*/}
    </QueryClientProvider>
  )
}

export default App
